// forks
//
// Purpose: Community fork preset categories
//
// This module:
// - Exports preset categories: UltraBox through Dogebox2

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const forkCategories: InputPresetCategory[] = [
	{
		name: "UltraBox Presets",
		presets: toNameMap([
			//
			{
				name: "distorted pulse vocal",
				generalMidi: false,
				tags: ["chip", "chipwave", "ultrabox", "distortion"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 8 },
						{ type: "peak", cutoffHz: 500, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 8 },
						{ type: "peak", cutoffHz: 500, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 11.3137 },
					],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					echoSustain: 14,
					echoDelayBeats: 0.167,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "1/8 pulse",
					unison: "none",
					envelopes: [],
				},
			},
			// from lognes
			{
				name: "dubstep bwah (Lognes)",
				generalMidi: false,
				tags: ["fm", "fm4op", "ultrabox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters1: [],
					effects: ["panning", "transition type", "chord type"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "note size" },
						{ target: "operatorAmplitude", envelope: "swell 2", index: 1 },
						{ target: "operatorAmplitude", envelope: "punch", index: 2 },
						{ target: "operatorAmplitude", envelope: "note size", index: 3 },
					],
				},
			},
			//
			{
				name: "FM cool bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ultrabox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					effects: ["transition type", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 7231.23, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7231.23, linearGain: 1 }],
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "punch" },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
					],
				},
			},
			//
			{
				name: "FM funky bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ultrabox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 0,
					eqSubFilters1: [],
					effects: ["transition type", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "punch" },
						{
							target: "noteVolume",
							envelope: "note size",
						},
					],
				},
			},
			//
			{
				name: "talking bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ultrabox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [],
					effects: ["chord type"],
					chord: "custom interval",
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15 },
						{ frequency: "2×", amplitude: 8 },
						{
							frequency: "2×",
							amplitude: 5,
						},
						{ frequency: "1×", amplitude: 12 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "note size", index: 2 },
						{
							target: "operatorAmplitude",
							envelope: "note size",
							index: 3,
						},
						{ target: "feedbackAmplitude", envelope: "note size" },
					],
				},
			},
			// from main
			{
				name: "synth marimba (Main)",
				generalMidi: false,
				tags: ["pickedstring", "ultrabox", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.5,
						},
					],
					effects: ["note filter", "echo"],
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 }],
					echoSustain: 71,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 29, 29, 0, 0, 0, 100, 0, 0, 0, 86, 29, 0, 14, 100, 0, 0, 0, 0, 0,
						14, 0, 0, 14, 0, 0, 86,
					],
					unison: "fifth",
					stringSustain: 7,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "punch" }],
				},
			},
			// from neputendo
			{
				name: "italian accordian (Neputendo)",
				generalMidi: false,
				tags: ["chip", "customchip", "ultrabox", "bellows"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 1,
					eqSubFilters1: [],
					effects: ["chorus", "reverb"],
					chorus: 71,
					reverb: 45,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					wave: "square",
					unison: "honky tonk",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -24,
						"37": -24,
						"38": -24,
						"39": -24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": -24,
						"49": -24,
						"50": -24,
						"51": -24,
						"52": -24,
						"53": -24,
						"54": -24,
						"55": -24,
						"56": -24,
						"57": -24,
						"58": -24,
						"59": -24,
						"60": -24,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			// from neputendo
			{
				name: "chip supersaw (Neputendo)",
				generalMidi: false,
				tags: ["chip", "customchip", "ultrabox", "chiptune", "featured"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters1: [],
					effects: ["transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "dissonant",
					customChipWave: {
						"0": 22,
						"1": 22,
						"2": 16,
						"3": 6,
						"4": 0,
						"5": -3,
						"6": -8,
						"7": -10,
						"8": -13,
						"9": -16,
						"10": -19,
						"11": -19,
						"12": -20,
						"13": -22,
						"14": -22,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": 24,
						"32": 24,
						"33": 16,
						"34": 9,
						"35": 6,
						"36": 4,
						"37": 2,
						"38": 0,
						"39": -1,
						"40": -3,
						"41": -4,
						"42": -4,
						"43": -6,
						"44": -6,
						"45": -6,
						"46": -6,
						"47": -5,
						"48": -5,
						"49": -4,
						"50": -2,
						"51": -2,
						"52": 1,
						"53": 4,
						"54": 6,
						"55": 8,
						"56": 10,
						"57": 12,
						"58": 14,
						"59": 16,
						"60": 18,
						"61": 19,
						"62": 22,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			// THANKS TO ANSWEARING MACHINE for the FM supersaw
			// is answering machine a song name or a person...? idk I'll cite it anyways
			{
				name: "fm supersaw (Answering Machine)",
				generalMidi: false,
				tags: ["fm", "fm6op", "ultrabox", "retro"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
					],
					effects: ["transition type", "pitch shift", "note filter", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					chorus: 71,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// based off of the todbox wind preset that was removed
			{
				name: "wind",
				generalMidi: false,
				tags: ["fm", "fm4op", "ultrabox", "ambience"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 250.03, linearGain: 11.3137 }],
					eqFilterType: true,
					eqSimpleCut: 0,
					eqSimplePeak: 7,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["transition type", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "16×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// this meow is from nobo
			{
				name: "mrow (Nobo)",
				generalMidi: false,
				tags: ["fm", "fm4op", "ultrabox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [],
					effects: ["chord type", "reverb"],
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					reverb: 35,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "flare 1", index: 0 },
						{ target: "operatorAmplitude", envelope: "note size", index: 1 },
						{ target: "operatorAmplitude", envelope: "note size", index: 2 },
						{ target: "operatorAmplitude", envelope: "flare 3", index: 3 },
						{ target: "feedbackAmplitude", envelope: "flare 1" },
					],
				},
			},
			// based off of the "obama why" beepcord inside joke so thanks to nobo ig
			{
				name: "vocal why",
				generalMidi: false,
				tags: ["harmonics", "ultrabox", "vocal"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					effects: ["note filter", "reverb"],
					noteFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 11.3137 }],
					reverb: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					harmonics: [
						100, 86, 29, 29, 14, 14, 0, 14, 14, 43, 71, 100, 100, 86, 71, 71, 57, 57,
						43, 43, 43, 43, 43, 0, 0, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "note size" }],
				},
			},
		]),
	},
	{
		name: "Slarmoo's Box Presets",
		presets: toNameMap([
			// custom presets from this mod
			// all created by Slarmoo
			{
				name: "radio fm",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "bellows", "ambience", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.3536,
						},
					],
					effects: ["detune", "vibrato", "bitcrusher", "reverb"],
					detuneCents: 0,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 43,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 7, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "anguished underworld",
				generalMidi: false,
				tags: ["fm", "fm6op", "slarmoo'sbox", "reed"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 2 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					reverb: 0,
					fadeInSeconds: 0.075,
					fadeOutTicks: 6,
					algorithm: "1 2←4 3←(5 6)",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "punch" },
						{
							target: "operatorAmplitude",
							envelope: "decay -1",
							index: 5,
						},
						{ target: "feedbackAmplitude", envelope: "wibble 3" },
					],
					isDrum: false,
				},
			},
			{
				name: "faint sorrow",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "ambience", "string"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4240.89, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["detune", "vibrato", "echo", "reverb"],
					detuneCents: 22,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					echoSustain: 100,
					echoDelayBeats: 0.667,
					reverb: 87,
					fadeInSeconds: 0.075,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "bright sorrow fm",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "arp"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 2.8284 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1.4142 }],
					echoSustain: 71,
					echoDelayBeats: 1.333,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "wet sorrow fm",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "lead"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["vibrato", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					reverb: 23,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "decay 3", index: 2 }],
					isDrum: false,
				},
			},
			{
				name: "scream fm",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.7071 },
					],
					effects: ["detune", "note filter", "distortion", "reverb"],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 1681.79, linearGain: 0.125 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 1681.79, linearGain: 0.125 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
					],
					distortion: 0,
					aliases: false,
					reverb: 87,
					fadeInSeconds: 0.135,
					fadeOutTicks: -3,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "4×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "detune", envelope: "swell 1" },
						{
							target: "feedbackAmplitude",
							envelope: "tremolo4",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "anguished radio fm pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "pad", "arp"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
					],
					eqSubFilters4: [],
					effects: ["detune", "note filter", "bitcrusher", "chorus", "echo", "reverb"],
					detuneCents: -16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 105.11, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					noteSubFilters4: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←3 2←4",
					feedbackType: "1→3",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "juicy kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "good vibes supersaw",
				generalMidi: false,
				tags: ["supersaw", "slarmoo'sbox", "featured", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 6,
					discreteEnvelope: false,
					pitchEnvelopeStart: 37,
					pitchEnvelopeEnd: 96,
					pitchEnvelopeInverse: true,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 30,
					chorus: 14,
					reverb: 23,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					pulseWidth: 26,
					decimalOffset: 0,
					dynamism: 33,
					spread: 33,
					shape: 17,
					envelopes: [
						{ target: "supersawShape", envelope: "pitch" },
						{
							target: "detune",
							envelope: "tremolo2",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "ethereal",
				generalMidi: false,
				isNoise: false,
				tags: ["spectrum", "slarmoo'sbox", "pad"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: 36,
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 36,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
					],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					chorus: 71,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						43, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "none",
					pitchEnvelopeStart0: 0,
					pitchEnvelopeEnd0: 96,
					envelopeInverse0: false,
					pitchEnvelopeStart1: 0,
					pitchEnvelopeEnd1: 96,
					envelopeInverse1: false,
					pitchEnvelopeStart2: 0,
					pitchEnvelopeEnd2: 96,
					envelopeInverse2: false,
					envelopes: [
						{ target: "noteVolume", envelope: "note size" },
						{
							target: "detune",
							envelope: "tremolo3",
						},
						{ target: "bitcrusherQuantization", envelope: "note size" },
					],
					isDrum: false,
				},
			},
			{
				name: "walrus wuh",
				generalMidi: false,
				tags: ["supersaw", "slarmoo'sbox", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					pitchEnvelopeStart: 0,
					pitchEnvelopeEnd: 96,
					pitchEnvelopeInverse: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
					],
					effects: ["note filter", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 71,
					chorus: 86,
					reverb: 32,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 48,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{ target: "noteVolume", envelope: "punch" },
						{
							target: "bitcrusherQuantization",
							envelope: "decay 3",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "saturnic",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "arp", "lead"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4240.89, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["vibrato", "chorus", "echo", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					chorus: 100,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 45,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "glassy harmonics",
				generalMidi: false,
				tags: ["harmonics", "slarmoo'sbox", "keys", "idiophone"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.5,
						},
					],
					effects: ["detune", "note filter", "chorus", "reverb"],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					chorus: 14,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 0, 43, 29, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 14, 29, 14, 0, 14, 0, 0, 0,
						0, 100, 0, 0, 14, 0,
					],
					unison: "none",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "plucked",
				generalMidi: false,
				tags: ["pickedstring", "slarmoo'sbox", "idiophone", "picked"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					effects: ["transition type", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					echoSustain: 100,
					echoDelayBeats: 1.333,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 86, 57, 0, 0, 57, 57, 57, 86, 57, 57, 43, 43, 43, 29, 29, 14, 14, 29,
						14, 14, 14, 29, 100, 57, 43, 14, 14,
					],
					unison: "none",
					stringSustain: 14,
					envelopes: [],
					isDrum: false,
				},
			},
			// 1.1.1 noise presets
			// 1.2 presets
			{
				name: "jungle bass",
				generalMidi: false,
				isNoise: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "bass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 148.65,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 148.65,
							linearGain: 0.0884,
						},
					],
					effects: ["vibrato", "note filter", "chorus", "reverb"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					chorus: 14,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←3 2←4",
					feedbackType: "1↔2 3↔4",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					pitchEnvelopeStart0: 0,
					pitchEnvelopeEnd0: 96,
					envelopeInverse0: false,
					pitchEnvelopeStart1: 0,
					pitchEnvelopeEnd1: 96,
					envelopeInverse1: false,
					pitchEnvelopeStart2: 12,
					pitchEnvelopeEnd2: 28,
					envelopeInverse2: false,
					envelopes: [
						{ target: "operatorFrequency", envelope: "swell 3", index: 0 },
						{
							target: "operatorAmplitude",
							envelope: "swell 3",
							index: 1,
						},
						{ target: "noteFilterFreq", envelope: "pitch", index: 0 },
					],
					isDrum: false,
				},
			},
			{
				name: "beach tide",
				generalMidi: false,
				isNoise: false,
				tags: ["harmonics", "slarmoo'sbox", "pad"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
					],
					effects: ["transition type", "chord type", "note filter", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.1768,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.1768,
						},
					],
					chorus: 14,
					reverb: 32,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 72,
					harmonics: [
						86, 86, 71, 57, 57, 43, 43, 43, 29, 29, 14, 14, 14, 0, 0, 57, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					pitchEnvelopeStart0: 0,
					pitchEnvelopeEnd0: 96,
					envelopeInverse0: false,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "pitch" }],
					isDrum: false,
				},
			},
			{
				name: "starlight",
				generalMidi: false,
				isNoise: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "pad", "bass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 }],
					effects: ["transition type", "vibrato", "bitcrusher", "echo", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "distant monument",
				generalMidi: false,
				isNoise: false,
				tags: ["chip", "chipwave", "slarmoo'sbox", "featured", "bass", "arp", "ambience"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 24,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 14,
					chorus: 86,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 12,
					wave: "modbox pnryshk a (u5)",
					unison: "detune",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 11,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					pitchEnvelopeStart0: 0,
					pitchEnvelopeEnd0: 96,
					envelopeInverse0: false,
					pitchEnvelopeStart1: 0,
					pitchEnvelopeEnd1: 96,
					envelopeInverse1: false,
					envelopes: [
						{ target: "noteVolume", envelope: "punch" },
						{
							target: "noteVolume",
							envelope: "twang 1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "mercurial",
				generalMidi: false,
				isNoise: false,
				tags: ["fm", "fm6op", "slarmoo'sbox", "bass"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
					],
					eqSubFilters1: [],
					effects: ["distortion", "chorus"],
					distortion: 43,
					aliases: false,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[3], [5], [4], [], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "linear",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "distortion",
							envelope: "twang",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			// 1.3 presets
			{
				name: "spectral phaser",
				generalMidi: false,
				tags: ["spectrum", "slarmoo'sbox", "pad"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 10,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 4 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 4 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.1768 },
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 14,
					chorus: 100,
					echoSustain: 86,
					echoDelayBeats: 1,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						86, 0, 0, 0, 57, 0, 0, 71, 0, 0, 0, 86, 0, 0, 57, 0, 43, 0, 43, 0, 0, 43, 0,
						29, 0, 29, 14, 14, 29, 14,
					],
					unison: "piano",
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.07,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.06,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.05,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.04,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.09,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 4,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 5,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 6,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0.03,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 7,
						},
						{
							target: "distortion",
							envelope: "none",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "distant sorrow",
				generalMidi: false,
				tags: ["harmonics", "slarmoo'sbox", "picked"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.5,
						},
					],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 }],
					echoSustain: 100,
					echoDelayBeats: 1,
					reverb: 74,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						86, 71, 57, 43, 43, 29, 57, 0, 14, 0, 29, 29, 29, 29, 29, 43, 43, 43, 43,
						43, 57, 57, 57, 0, 57, 57, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "fall",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "metallic kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "kick"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 28,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "256x", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "128x", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "256x", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
					],
					isDrum: false,
				},
			},
			// 1.4 presets
			{
				name: "chimes",
				generalMidi: false,
				tags: ["pickedstring", "slarmoo'sbox", "idiophone"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 2.8284 },
					],
					effects: [
						"chord type",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 29,
					echoSustain: 86,
					echoDelayBeats: 0.667,
					reverb: 84,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						0, 100, 71, 71, 29, 0, 57, 86, 0, 0, 0, 0, 71, 29, 0, 0, 57, 0, 0, 86, 0, 0,
						0, 100, 0, 100, 0, 57,
					],
					unison: "none",
					stringSustain: 36,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "stringSustain",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							steps: 14,
							seed: 2,
							waveform: 0,
						},
						{
							target: "detune",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "supersaw bass",
				generalMidi: false,
				tags: ["supersaw", "slarmoo'sbox", "bass"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 }],
					effects: ["note filter", "distortion", "chorus", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 7231.23, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7231.23, linearGain: 1 }],
					distortion: 14,
					aliases: false,
					chorus: 29,
					reverb: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 67,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "ascension",
				generalMidi: false,
				isNoise: false,
				tags: ["spectrum", "slarmoo'sbox", "pad"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					eqSubFilters1: [],
					effects: ["granular", "chorus", "reverb"],
					granular: 7,
					grainSize: 44,
					grainAmounts: 9,
					grainRange: 37,
					chorus: 71,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					spectrum: [
						43, 0, 0, 57, 0, 0, 14, 100, 29, 0, 0, 100, 29, 0, 100, 0, 57, 29, 86, 14,
						14, 100, 14, 0, 14, 14, 0, 0, 43, 0,
					],
					unison: "voiced",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 6,
						},
					],
					isDrum: false,
				},
			},
		]),
	},
	{
		name: "Slarmoo's Box Chip Presets",
		presets: toNameMap([
			// Made by Slarmoo
			{
				name: "Slarmoo's Pulse",
				midiProgram: 80,
				tags: ["pwm", "slarmoo'sbox", "retro", "chiptune"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "chord type", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 8,
					detuneCents: 24,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					pitchEnvelopeStart0: 0,
					pitchEnvelopeEnd0: 96,
					envelopeInverse0: false,
					envelopes: [{ target: "detune", envelope: "pitch" }],
					isDrum: false,
				},
			},
			{
				name: "discovery square",
				midiProgram: 80,
				tags: ["chip", "chipwave", "slarmoo'sbox", "retro", "pad"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					effects: ["bitcrusher"],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 57,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			// sourced from masked eternity; likely originally made by someone else
			{
				name: "VRC6 Sawtooth alt",
				midiProgram: 81,
				tags: ["chip", "customchip", "slarmoo'sbox", "chiptune", "retro"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.5 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"distortion",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: 0,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 0,
					aliases: false,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -1,
						"1": -1,
						"2": -1,
						"3": -1,
						"4": -1,
						"5": -1,
						"6": -1,
						"7": -1,
						"8": -1,
						"9": -5,
						"10": -5,
						"11": -5,
						"12": -4,
						"13": -4,
						"14": -4,
						"15": -3,
						"16": -3,
						"17": -3,
						"18": -7,
						"19": -7,
						"20": -6,
						"21": -6,
						"22": -5,
						"23": -5,
						"24": -4,
						"25": -4,
						"26": -4,
						"27": -7,
						"28": -7,
						"29": -6,
						"30": -6,
						"31": -5,
						"32": -5,
						"33": -4,
						"34": -4,
						"35": -4,
						"36": -8,
						"37": -8,
						"38": -7,
						"39": -7,
						"40": -6,
						"41": -6,
						"42": -5,
						"43": -5,
						"44": -4,
						"45": -4,
						"46": 21,
						"47": 20,
						"48": 18,
						"49": 17,
						"50": 16,
						"51": 14,
						"52": 13,
						"53": 12,
						"54": 11,
						"55": 7,
						"56": 6,
						"57": 6,
						"58": 5,
						"59": 5,
						"60": 5,
						"61": 4,
						"62": 4,
						"63": 4,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			// Made by Slarmoo
			{
				name: "pulse arps",
				midiProgram: 80,
				tags: ["pwm", "slarmoo'sbox", "featured", "arp", "retro"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 7,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 2,
						},
					],
					effects: ["transition type", "chord type", "detune", "chorus", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 8,
					detuneCents: 64,
					chorus: 43,
					echoSustain: 71,
					echoDelayBeats: 0.333,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "detune",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "pulseWidth",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							pitchEnvelopeStart: 24,
							pitchEnvelopeEnd: 83,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "chorus",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
		]),
	},
	{
		name: "Slarmoo's Box Instrumental Presets",
		presets: toNameMap([
			// Made by Slarmoo
			{
				name: "rusty flute",
				midiProgram: 73,
				tags: ["fm", "fm4op", "slarmoo'sbox", "flute"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 13454.34, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 13454.34, linearGain: 2.8284 }],
					effects: ["transition type", "detune", "distortion", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -7,
					distortion: 14,
					aliases: false,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←2←3←4",
					feedbackType: "3→4",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "bitcrushed piano",
				midiProgram: 4,
				tags: ["chip", "chipwave", "slarmoo'sbox", "keys"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.5 },
					],
					effects: ["transition type", "detune", "distortion", "bitcrusher", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: 0,
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "detuned piano",
				midiProgram: 3,
				tags: ["pickedstring", "slarmoo'sbox", "keys"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					effects: ["transition type", "detune", "vibrato", "note filter", "bitcrusher"],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: 44,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 13,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						86, 86, 71, 71, 57, 57, 43, 29, 14, 29, 29, 29, 29, 29, 29, 29, 29, 43, 43,
						43, 43, 43, 29, 14, 14, 0, 0, 0,
					],
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.26,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 1,
					stringSustain: 79,
					envelopes: [
						{
							target: "detune",
							envelope: "random",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 49,
							waveform: 1,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
						{
							target: "unison",
							envelope: "random",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 20,
							waveform: 1,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: true,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "pan flute 2",
				midiProgram: 75,
				isNoise: false,
				tags: ["spectrum", "slarmoo'sbox", "flute", "lead"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.3536,
						},
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.3536,
						},
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
					],
					effects: ["transition type", "note filter", "bitcrusher", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 57,
					reverb: 16,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -6,
					spectrum: [
						100, 29, 14, 14, 57, 0, 0, 71, 0, 86, 57, 43, 57, 71, 14, 29, 14, 14, 14,
						100, 71, 14, 14, 14, 14, 86, 43, 14, 0, 0,
					],
					unison: "none",
					pitchEnvelopeStart0: 0,
					pitchEnvelopeEnd0: 96,
					envelopeInverse0: false,
					pitchEnvelopeStart1: 0,
					pitchEnvelopeEnd1: 96,
					envelopeInverse1: false,
					pitchEnvelopeStart2: 0,
					pitchEnvelopeEnd2: 96,
					envelopeInverse2: false,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
						},
						{ target: "noteVolume", envelope: "note size" },
					],
					isDrum: false,
				},
			},
			{
				name: "trumpet 2",
				midiProgram: 56,
				tags: ["fm", "fm4op", "slarmoo'sbox", "brass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["detune", "vibrato", "note filter", "distortion", "chorus", "reverb"],
					detuneCents: -64,
					vibrato: "custom",
					vibratoDepth: 0.68,
					vibratoDelay: 17,
					vibratoSpeed: 12,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.1768,
						},
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.1768,
						},
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.1768 },
					],
					distortion: 29,
					aliases: false,
					chorus: 14,
					reverb: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					operators: [
						{
							frequency: "0.75×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 2,
						},
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "decay",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "detune",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: true,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "harp 2",
				midiProgram: 46,
				tags: ["fm", "fm6op", "slarmoo'sbox", "picked"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
					],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "echo", "reverb"],
					detuneCents: -23,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 2.8284,
						},
					],
					echoSustain: 29,
					echoDelayBeats: 1.083,
					reverb: 74,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "tremolo",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "detune",
							envelope: "decay",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "tremolo2",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: true,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "electric guitar 1",
				midiProgram: 30,
				tags: ["fm", "fm4op", "slarmoo'sbox", "distortion"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
					],
					effects: ["chord type", "vibrato", "note filter", "distortion", "reverb"],
					chord: "monophonic",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 0,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "vibratoDepth",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "electric guitar 2",
				midiProgram: 30,
				tags: ["pwm", "slarmoo'sbox", "distortion"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 1681.79,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 1681.79,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					chord: "monophonic",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 0,
					vibrato: "custom",
					vibratoDepth: 0.68,
					vibratoDelay: 22,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					chorus: 14,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.3333,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
		]),
	},
	{
		name: "Sandbox Presets",
		presets: toNameMap([
			{
				name: "sandbox abnormality",
				generalMidi: false,
				midiSubharmonicOctaves: 1,
				tags: ["chip", "chipwave", "sandbox"],
				settings: {
					type: "chip",
					effects: "none",
					transition: "seamless",
					chord: "arpeggio",
					filterCutoffHz: 8000,
					filterResonance: 0,
					filterEnvelope: "steady",
					wave: "spiky",
					interval: "fifth",
					vibrato: "none",
				},
			},
			{
				name: "sandbox playstation",
				generalMidi: false,
				midiSubharmonicOctaves: 1,
				tags: ["chip", "chipwave", "sandbox"],
				settings: {
					type: "chip",
					effects: "chorus",
					transition: "seamless",
					chord: "harmony",
					filterCutoffHz: 1414,
					filterResonance: 29,
					filterEnvelope: "steady",
					wave: "glitch",
					interval: "shimmer",
					vibrato: "none",
				},
			},
			{
				name: "sandbox harmony pulse",
				generalMidi: false,
				midiSubharmonicOctaves: 1,
				tags: ["chip", "chipwave", "sandbox"],
				settings: {
					type: "chip",
					effects: "chorus",
					transition: "soft",
					chord: "harmony",
					filterCutoffHz: 4000,
					filterResonance: 29,
					filterEnvelope: "punch",
					wave: "double pulse",
					interval: "union",
					vibrato: "none",
				},
			},
			{
				name: "sandbox clean pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "sandbox", "chiptune"],
				settings: {
					type: "custom chip",
					transition: "hard",
					effects: "none",
					chord: "arpeggio",
					filterCutoffHz: 4000,
					filterResonance: 0,
					filterEnvelope: "steady",
					interval: "union",
					vibrato: "none",
					customChipWave: [
						-24, -24, -24, -24, -24, -24, -24, -24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
						24, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -24, -24, -24, -24, -24, -24,
						-24, -24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 1, 1, 1, 1, 1, 1,
						1, 1, 1, 1, 1, 1,
					],
				},
			},
			{
				name: "sandbox snp chorus",
				generalMidi: false,
				tags: ["fm", "fm4op", "sandbox"],
				settings: {
					type: "FM",
					transition: "hard",
					effects: "chorus & reverb",
					chord: "strum",
					filterCutoffHz: 2000,
					filterResonance: 0,
					filterEnvelope: "twang 2",
					vibrato: "none",
					algorithm: "1←(2 3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 1,
					feedbackEnvelope: "flare 1",
					operators: [
						{ frequency: "1×", amplitude: 15, envelope: "custom" },
						{ frequency: "2×", amplitude: 15, envelope: "custom" },
						{ frequency: "4×", amplitude: 10, envelope: "custom" },
						{ frequency: "3×", amplitude: 6, envelope: "custom" },
					],
				},
			},
			{
				name: "sandbox snp echo",
				generalMidi: false,
				tags: ["fm", "fm4op", "sandbox"],
				settings: {
					type: "FM",
					transition: "hard fade",
					effects: "chorus",
					chord: "strum",
					filterCutoffHz: 8000,
					filterResonance: 0,
					filterEnvelope: "steady",
					vibrato: "none",
					algorithm: "1←(2 3←4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 5,
					feedbackEnvelope: "decay 2",
					operators: [
						{ frequency: "1×", amplitude: 15, envelope: "custom" },
						{ frequency: "2×", amplitude: 15, envelope: "custom" },
						{ frequency: "20×", amplitude: 9, envelope: "twang 1" },
						{ frequency: "20×", amplitude: 5, envelope: "twang 2" },
					],
				},
			},
			{
				name: "sandbox tori synth lead",
				generalMidi: false,
				tags: ["harmonics", "sandbox", "lead"],
				settings: {
					type: "harmonics",
					effects: "chorus",
					transition: "seamless",
					chord: "harmony",
					filterCutoffHz: 2000,
					filterResonance: 0,
					filterEnvelope: "steady",
					interval: "union",
					vibrato: "none",
					harmonics: [
						100, 100, 100, 100, 71, 71, 43, 43, 43, 29, 29, 43, 43, 43, 43, 43, 43, 43,
						43, 43, 43, 43, 29, 14, 0, 0, 0, 86,
					],
				},
			},
			{
				name: "sandbox glorious piano 1",
				generalMidi: false,
				tags: ["chip", "customchip", "sandbox", "keys"],
				settings: {
					type: "custom chip",
					transition: "hard fade",
					effects: "chorus & reverb",
					chord: "harmony",
					filterCutoffHz: 2828,
					filterResonance: 14,
					filterEnvelope: "steady",
					interval: "union",
					vibrato: "none",
					customChipWave: [
						24, 24, -16, -15, -15, -14, -13, -13, -12, -11, -11, -10, -9, -8, -8, -7,
						-6, -5, -5, -4, -3, -2, -2, 23, 22, 22, 21, 20, 20, 19, 19, 18, 18, 17, 16,
						15, 15, 14, 13, 12, 12, 11, 0, -1, -1, -2, -3, -3, -4, -5, -5, -6, -20, -19,
						-17, -17, -14, -11, -8, -5, -2, -23, -24, -24,
					],
				},
			},
			{
				name: "sandbox glorious piano 2",
				generalMidi: false,
				tags: ["chip", "customchip", "sandbox", "keys"],
				settings: {
					type: "custom chip",
					transition: "hard fade",
					effects: "chorus & reverb",
					chord: "harmony",
					filterCutoffHz: 2828,
					filterResonance: 14,
					filterEnvelope: "punch",
					interval: "shimmer",
					vibrato: "light",
					customChipWave: [
						24, 24, -16, -15, -15, -14, -13, -13, -12, 12, 9, 5, 2, -3, -7, -10, -6, -5,
						-5, -4, -3, -2, -2, 23, 22, 22, 21, 20, 20, 19, 19, 18, 18, 17, 16, 15, 15,
						0, 4, 8, 15, 21, 0, -1, -1, -2, -3, -3, -4, -5, -5, -6, -20, -19, -17, -17,
						-2, -2, -8, 2, -2, -5, -24, -24,
					],
				},
			},
			{
				name: "sandbox muffled katrumpet",
				generalMidi: false,
				tags: ["chip", "customchip", "sandbox", "chiptune"],
				settings: {
					type: "custom chip",
					transition: "cross fade",
					effects: "reverb",
					chord: "strum",
					filterCutoffHz: 5657,
					filterResonance: 29,
					filterEnvelope: "steady",
					interval: "union",
					vibrato: "light",
					customChipWave: [
						24, 23, 22, 22, 22, 22, 22, 21, 21, 19, 19, 15, 11, 7, 5, -2, -5, -11, -13,
						-14, -16, -17, -17, -17, -17, -17, -17, -17, -17, -13, -10, -1, 4, 6, 8, 10,
						11, 14, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 15, 15, 14, 11, 8, 4, 2, -4,
						-7, -11, -12, -13, -14, -15, -15, -15,
					],
				},
			},
			{
				name: "sandbox ehruthing",
				generalMidi: false,
				tags: ["chip", "customchip", "sandbox"],
				settings: {
					type: "custom chip",
					"hard fade": "seamless",
					effects: "reverb",
					chord: "strum",
					filterCutoffHz: 5657,
					filterResonance: 14,
					filterEnvelope: "twang 2",
					interval: "union",
					vibrato: "none",
					customChipWave: [
						24, 24, 23, 22, 21, 21, 20, 19, 18, 18, 17, 16, 15, -22, -20, -18, -16, -14,
						-13, -11, -10, -7, -6, -4, -3, -2, 0, 2, 4, 17, 16, 15, 13, 12, 11, 9, 8, 6,
						5, 4, 3, 2, 1, -1, -1, -2, -3, -4, -6, -6, -7, -8, -8, -9, -10, -10, -11,
						-13, -15, -16, -17, -3, -4, -5,
					],
				},
			},
			{
				name: "sandbox wurtz organ",
				generalMidi: false,
				tags: ["fm", "fm4op", "sandbox", "bellows"],
				settings: {
					type: "FM",
					transition: "seamless",
					effects: "chorus",
					chord: "harmony",
					filterCutoffHz: 1414,
					filterResonance: 0,
					filterEnvelope: "punch",
					vibrato: "none",
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					feedbackEnvelope: "decay 2",
					operators: [
						{ frequency: "1×", amplitude: 14, envelope: "tremolo6" },
						{ frequency: "2×", amplitude: 9, envelope: "tripolo3" },
						{ frequency: "4×", amplitude: 5, envelope: "pentolo3" },
						{ frequency: "8×", amplitude: 2, envelope: "pentolo6" },
					],
				},
			},
			// some of these dont load
		]),
	},
	{
		name: "Midbox Misc Presets",
		presets: toNameMap([
			// { name: "Name", generalMidi: false, tags:["", "midbox"], settings: {} },
			{
				name: "Broken Music Box",
				midiProgram: 21,
				generalMidi: true,
				tags: ["chip", "chipwave", "midbox", "idiophone"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.72,
					vibratoDelay: 19,
					vibratoSpeed: 30,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "rounded",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterFreq", envelope: "twang 1", index: 0 }],
				},
			},
			{
				name: "Enhanced Synth Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.25 },
					],
					effects: [
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
					],
					pitchShiftSemitones: 24,
					vibrato: "custom",
					vibratoDepth: 2,
					vibratoDelay: 0,
					vibratoSpeed: 30,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 13,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{ target: "noteVolume", envelope: "twang 3" },
						{ target: "feedbackAmplitude", envelope: "twang 1" },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 0 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "pitchShift", envelope: "twang 2" },
					],
				},
			},
			{
				name: "Scratch String",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "string"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.25,
						},
					],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.3536 }],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←2←(3 4)",
					feedbackType: "1→4",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "swell 1", index: 3 },
						{
							target: "operatorAmplitude",
							envelope: "tremolo1",
							index: 1,
						},
					],
				},
			},
			{
				name: "Xylophone Saw",
				generalMidi: false,
				tags: ["chip", "customchip", "midbox", "featured"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 0.1768,
						},
					],
					effects: [
						"chord type",
						"pitch shift",
						"vibrato",
						"bitcrusher",
						"chorus",
						"echo",
					],
					chord: "simultaneous",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": -12,
						"12": -12,
						"13": -12,
						"14": -12,
						"15": -12,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 12,
						"23": 12,
						"24": 12,
						"25": 12,
						"26": 12,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": -11,
						"44": -11,
						"45": -11,
						"46": -11,
						"47": -11,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 12,
						"55": 12,
						"56": 12,
						"57": 12,
						"58": 12,
						"59": 12,
						"60": 12,
						"61": 12,
						"62": 12,
						"63": 12,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "noteVolume", envelope: "twang 2" }],
				},
			},
			{
				name: "Bow Bass",
				generalMidi: false,
				tags: ["chip", "customchip", "midbox", "bass"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
					],
					effects: [
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
					],
					chord: "simultaneous",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 19,
					vibrato: "custom",
					vibratoDepth: 0.36,
					vibratoDelay: 0,
					vibratoSpeed: 30,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 12,
					unisonOffset: -12,
					unisonExpression: 1,
					unisonSign: 1,
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 2", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "twang 2",
							index: 1,
						},
					],
				},
			},
			{
				name: "Disco Vocal Lead",
				generalMidi: false,
				tags: ["pickedstring", "midbox", "lead"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 4,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 100,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						43, 71, 100, 0, 0, 100, 0, 57, 0, 0, 0, 86, 29, 0, 0, 0, 0, 14, 0, 14, 14,
						0, 0, 0, 0, 43, 0, 0,
					],
					unison: "piano",
					stringSustain: 93,
					envelopes: [],
				},
			},
			{
				name: "Blessed Piano",
				generalMidi: false,
				tags: ["chip", "chipwave", "midbox", "keys"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 707.11, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 707.11, linearGain: 4 }],
					effects: [
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.48,
					vibratoDelay: 11,
					vibratoSpeed: 16,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 86,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "triangle",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6,
					unisonOffset: 6.5,
					unisonExpression: 0.8,
					unisonSign: 1,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "punch",
						},
					],
				},
			},
			{
				name: "Sawtooth Pluck",
				generalMidi: false,
				tags: ["chip", "chipwave", "midbox", "picked"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 4 },
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 1 },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 0 },
						{ target: "noteFilterFreq", envelope: "swell 1", index: 2 },
					],
				},
			},
			{
				name: "Desolated Piano",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					effects: ["pitch shift", "vibrato", "bitcrusher", "chorus", "reverb"],
					pitchShiftSemitones: 24,
					vibrato: "custom",
					vibratoDepth: 0.6,
					vibratoDelay: 1,
					vibratoSpeed: 18,
					vibratoType: 0,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 29,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 3, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "vibratoDepth", envelope: "twang 2" },
						{ target: "feedbackAmplitude", envelope: "twang 2" },
						{ target: "operatorAmplitude", envelope: "decay 1", index: 1 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
					],
				},
			},
			{
				name: "Distorted Guitar 1",
				generalMidi: false,
				tags: ["pickedstring", "midbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["note filter", "distortion", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 },
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterFreq", envelope: "note size", index: 1 }],
				},
			},
			{
				name: "Distorted Guitar 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "distortion", "guitar"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.5 },
					],
					effects: ["note filter", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 2000, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 2000, linearGain: 2.8284 },
					],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 43,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "2×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 10, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Distorted Guitar 3",
				generalMidi: false,
				tags: ["pickedstring", "midbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 500, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 500, linearGain: 4 },
					],
					effects: ["pitch shift", "note filter", "distortion", "chorus", "reverb"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.3536,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 14,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 0, 86, 0, 43, 0, 100, 43, 0, 29, 0, 100, 0, 0, 0, 71, 43, 0, 0, 0, 14,
						0, 0, 0, 0, 0, 0, 29,
					],
					unison: "none",
					stringSustain: 0,
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "High Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 8,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 8,
						},
					],
					effects: ["pitch shift", "vibrato", "note filter", "chorus"],
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.28,
					vibratoDelay: 19,
					vibratoSpeed: 30,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					panDelay: 10,
					chorus: 86,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "4×", amplitude: 13, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "0.12×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{ target: "feedbackAmplitude", envelope: "twang 1" },
						{ target: "feedbackAmplitude", envelope: "twang 1" },
						{ target: "feedbackAmplitude", envelope: "twang 1" },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
					],
				},
			},
			{
				name: "Magical Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "midbox", "pad"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 }],
					effects: ["transition type", "pitch shift", "vibrato", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					vibrato: "custom",
					vibratoDepth: 0.56,
					vibratoDelay: 27,
					vibratoSpeed: 14,
					vibratoType: 0,
					panDelay: 10,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "sawtooth",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.03,
					unisonOffset: -0.02,
					unisonExpression: 0.85,
					unisonSign: 0.7,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "swell 3" }],
				},
			},
			{
				name: "Distorted Lead",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "lead"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "distortion", "bitcrusher", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 2,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 11, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "1×", amplitude: 8, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "FM Punch Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2.8284 }],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2.8284 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 7, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 1", index: 0 },
						{
							target: "feedbackAmplitude",
							envelope: "punch",
						},
						{ target: "noteVolume", envelope: "twang 2" },
					],
				},
			},
			{
				name: "Rough Glistening Piano",
				generalMidi: false,
				tags: ["harmonics", "midbox", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.1768,
						},
					],
					effects: ["chord type", "note filter", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 71, 43, 29, 29, 14, 14, 43, 0, 43, 0, 57, 71, 0, 71, 43, 0, 0, 57, 0,
						57, 0, 71, 0, 71, 0, 57, 0,
					],
					unison: "honky tonk",
					envelopes: [{ target: "noteFilterFreq", envelope: "twang 2", index: 0 }],
				},
			},
			{
				name: "Soft Glistening Piano",
				generalMidi: false,
				tags: ["harmonics", "midbox", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					effects: ["chord type", "detune", "note filter", "chorus", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: -20,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 29,
					reverb: 97,
					fadeInSeconds: 0.135,
					fadeOutTicks: 48,
					harmonics: [
						100, 0, 0, 29, 29, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 43,
						14, 0, 0, 0, 0,
					],
					unison: "honky tonk",
					envelopes: [{ target: "noteFilterFreq", envelope: "twang 2", index: 0 }],
				},
			},
			{
				name: "Jingle Bells",
				generalMidi: false,
				tags: ["harmonics", "midbox", "featured", "idiophone"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 707.11,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 707.11,
							linearGain: 2,
						},
					],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 8,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
					],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1.667,
					reverb: 77,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 29, 57, 71, 0, 0, 0, 0, 0, 0, 0, 14, 43, 14, 0, 0, 0, 0, 0, 0, 14, 0,
						14, 14, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "twang 2" }],
				},
			},
			{
				name: "Otherworldly Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "kick", "featured"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["pitch shift", "vibrato", "distortion", "bitcrusher", "chorus"],
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.92,
					vibratoDelay: 18,
					vibratoSpeed: 30,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{ target: "noteVolume", envelope: "twang 3" },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "pitchShift", envelope: "twang 1" },
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
					],
				},
			},
			{
				name: "Bitcrushed Piano",
				generalMidi: false,
				tags: ["chip", "chipwave", "midbox", "featured", "keys"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					vibrato: "custom",
					vibratoDepth: 0.72,
					vibratoDelay: 19,
					vibratoSpeed: 30,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "triangle",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.000211,
					unisonOffset: -0.3,
					unisonExpression: 0.8,
					unisonSign: 1,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterFreq", envelope: "twang 1", index: 0 }],
				},
			},
			{
				name: "Boop Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "midbox", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					effects: ["transition type", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					panDelay: 10,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.000211,
					unisonOffset: -0.3,
					unisonExpression: 0.8,
					unisonSign: 1,
					customChipWave: {
						"0": -1,
						"1": 1,
						"2": -1,
						"3": -4,
						"4": -6,
						"5": -8,
						"6": -11,
						"7": -12,
						"8": -15,
						"9": -16,
						"10": -18,
						"11": -19,
						"12": -21,
						"13": -22,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -23,
						"19": -22,
						"20": -21,
						"21": -19,
						"22": -17,
						"23": -16,
						"24": -14,
						"25": -13,
						"26": -10,
						"27": -8,
						"28": -6,
						"29": -4,
						"30": -2,
						"31": -1,
						"32": 2,
						"33": 3,
						"34": 5,
						"35": 7,
						"36": 10,
						"37": 12,
						"38": 14,
						"39": 16,
						"40": 18,
						"41": 19,
						"42": 20,
						"43": 21,
						"44": 23,
						"45": 23,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 23,
						"59": 22,
						"60": 21,
						"61": 19,
						"62": 16,
						"63": 14,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{ target: "noteVolume", envelope: "twang 2" },
						{
							target: "noteFilterFreq",
							envelope: "twang 2",
							index: 0,
						},
					],
				},
			},
			{
				name: "Spectrum Pad",
				generalMidi: false,
				tags: ["spectrum", "midbox", "pad"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 2,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["vibrato", "distortion", "bitcrusher", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					envelopes: [],
				},
			},
			{
				name: "Countdown Pulse",
				generalMidi: false,
				tags: ["pwm", "midbox", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "peak", cutoffHz: 2828.43, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2828.43, linearGain: 2 }],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 16,
					detuneCents: 196,
					panDelay: 10,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.5,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 42,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "pitchShift",
							envelope: "twang 1",
						},
					],
				},
			},
			{
				name: "Ambient Pulse 1",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "retro"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
					],
					effects: ["note filter", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 1.333,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "3×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "flare 1", index: 2 }],
				},
			},
			{
				name: "Saturn Pad",
				generalMidi: false,
				tags: ["pickedstring", "midbox", "pad"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						0, 100, 100, 100, 0, 0, 0, 0, 43, 43, 0, 86, 0, 100, 0, 29, 0, 0, 0, 0, 71,
						57, 0, 0, 86, 0, 0, 43,
					],
					unison: "shimmer",
					stringSustain: 93,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "tremolo3" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Build-Up Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					panDelay: 10,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "3×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "flare 1", index: 2 }],
				},
			},
			{
				name: "Ambient Pulse 2",
				generalMidi: false,
				tags: ["harmonics", "midbox", "retro"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 420.45, linearGain: 8 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 420.45, linearGain: 8 },
					],
					effects: ["chord type", "note filter", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1 }],
					panDelay: 10,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					harmonics: [
						57, 57, 71, 57, 43, 43, 43, 71, 43, 43, 43, 57, 71, 86, 100, 86, 57, 57, 43,
						43, 43, 57, 43, 29, 43, 57, 57, 43,
					],
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.0018,
					unisonOffset: 0,
					unisonExpression: 0.85,
					unisonSign: 1.6,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "tremolo5" }],
				},
			},
			{
				name: "Hyper Synth Saw",
				generalMidi: false,
				tags: ["chip", "chipwave", "midbox"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 1.4142,
						},
					],
					effects: [
						"chord type",
						"detune",
						"vibrato",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 16,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 14,
					aliases: false,
					panDelay: 10,
					chorus: 86,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "sawtooth",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.0018,
					unisonOffset: 0,
					unisonExpression: 0.85,
					unisonSign: 1.6,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Another Piano",
				generalMidi: false,
				tags: ["pwm", "midbox", "featured", "keys"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1 },
					],
					effects: ["detune", "note filter", "reverb"],
					detuneCents: 16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 }],
					panDelay: 10,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 44,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "punch" },
						{ target: "noteVolume", envelope: "twang 2" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
					],
				},
			},
		]),
	},
	{
		name: "Midbox Dubstep Presets",
		presets: toNameMap([
			// { name: "Name", generalMidi: false, tags:["", "midbox"], settings: {} },
			{
				name: "Dubstep Bwayyyy",
				generalMidi: false,
				tags: ["pwm", "midbox", "dubstep", "bass"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.5 },
					],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 23,
					vibratoSpeed: 26,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 11.3137 }],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 71,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 30,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "noteFilterFreq", envelope: "swell 3", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "swell 2",
							index: 0,
						},
					],
				},
			},
			{
				name: "Dubstep Bass Hum",
				generalMidi: false,
				tags: ["pwm", "midbox", "dubstep", "bass"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2 },
					],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 23,
					vibratoSpeed: 26,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 2,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 43,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 10,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "flare 1", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "flare 3",
							index: 0,
						},
					],
				},
			},
			{
				name: "Dubstep Yaa",
				generalMidi: false,
				tags: ["pwm", "midbox", "dubstep", "bass"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 },
					],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 23,
					vibratoSpeed: 26,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 86,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 8,
					decimalOffset: 0,
					unison: "none",
					envelopes: [{ target: "noteFilterFreq", envelope: "swell 1", index: 0 }],
				},
			},
			{
				name: "Dubstep Yeoww",
				generalMidi: false,
				tags: ["pwm", "midbox", "dubstep", "bass"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 },
					],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 23,
					vibratoSpeed: 26,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 11.3137 }],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 86,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 40,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 3", index: 0 },
						{
							target: "pulseWidth",
							envelope: "tremolo6",
						},
					],
				},
			},
			{
				name: "Dubstep Lead",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "dubstep", "lead"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 }],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 1000,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 1000,
							linearGain: 2,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 86,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "note size",
							index: 1,
						},
					],
				},
			},
			{
				name: "Dubstep Dyaii",
				generalMidi: false,
				tags: ["pickedstring", "midbox", "dubstep", "bass"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
					],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 23,
					vibratoSpeed: 26,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 8 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 8 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 11.3137,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 71,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 0, 71, 86, 0, 0, 100, 86, 86, 71, 57, 57, 29, 14, 57, 71, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 100,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Dubstep Alarm",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "dubstep"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.5,
						},
					],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 11.3137 },
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterFreq", envelope: "note size", index: 0 }],
				},
			},
		]),
	},
	{
		name: "AbyssBox Presets",
		presets: toNameMap([
			{
				name: "Demonic Bell",
				generalMidi: false,
				tags: ["pickedstring", "abyssbox", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
					],
					effects: ["detune", "distortion", "bitcrusher", "echo", "reverb"],
					detuneCents: -52,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						43, 71, 71, 100, 86, 100, 43, 86, 71, 57, 86, 29, 14, 71, 14, 14, 57, 14,
						14, 43, 14, 14, 43, 14, 14, 43, 14, 14,
					],
					unison: "shimmer",
					stringSustain: 64,
					envelopes: [],
				},
			},
			{
				name: "Spacey Triangle",
				generalMidi: false,
				tags: ["chip", "chipwave", "abyssbox"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					effects: [
						"transition type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 86,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "triangle",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Harmonic Piano",
				generalMidi: false,
				tags: ["harmonics", "abyssbox", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.125,
						},
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.125,
						},
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1 },
					],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 57, 57, 57, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Organic Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "abyssbox", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 }],
					effects: ["chord type", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					panDelay: 10,
					reverb: 71,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 1", index: 3 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Nokia Ringtone",
				generalMidi: false,
				tags: ["fm", "fm4op", "abyssbox"],
				settings: {
					type: "FM",
					eqFilter: [],
					effects: ["transition type", "chord type"],
					transition: "interrupt",
					chord: "custom interval",
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1→2",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 2 },
						{ frequency: "1×", amplitude: 15 },
						{
							frequency: "1×",
							amplitude: 15,
						},
						{ frequency: "1×", amplitude: 15 },
					],
					envelopes: [],
				},
			},
			{
				name: "Supersaw Pluck",
				generalMidi: false,
				tags: ["supersaw", "abyssbox", "picked"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 9,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "note filter", "chorus", "echo", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 40,
					decimalOffset: 0,
					dynamism: 67,
					spread: 50,
					shape: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
			{
				name: "Credits Bass",
				generalMidi: false,
				tags: ["chip", "chipwave", "abyssbox", "bass"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["transition type", "chord type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 9,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "alto sax",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "decay 1" }],
				},
			},
			{
				name: "FM Violin",
				generalMidi: false,
				tags: ["fm", "fm6op", "abyssbox", "string"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "distortion", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 43,
					aliases: false,
					panDelay: 10,
					chorus: 14,
					echoSustain: 14,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customAlgorithm: {
						mods: [[6, 2, 3, 4, 5], [], [], [], [], []],
						carrierCount: 2,
					},
					customFeedback: { mods: [[1], [], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "rounded", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "twang 3" },
						{
							target: "noteVolume",
							envelope: "swell 2",
						},
					],
				},
			},
			{
				name: "Shamisen 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "abyssbox", "picked"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customAlgorithm: {
						mods: [[6, 2, 3, 4, 5], [], [], [], [], []],
						carrierCount: 2,
					},
					customFeedback: { mods: [[1], [], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "rounded", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
			{
				name: "Picked Dist Guitar",
				generalMidi: false,
				tags: ["pickedstring", "abyssbox", "distortion", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "distortion", "bitcrusher"],
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 19,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.5,
						},
					],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 86, 86, 86, 71, 57, 71, 71, 14, 14, 14, 29, 57, 43, 43, 57, 43, 29, 29,
						29, 29, 29, 29, 43, 43, 43, 0, 71,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "noteVolume",
							envelope: "punch",
						},
					],
				},
			},
			{
				name: "Future Keys",
				generalMidi: false,
				tags: ["harmonics", "abyssbox", "featured", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.25 }],
					effects: ["chorus", "echo", "reverb", "phaser"],
					phaserMix: 100,
					phaserFreq: 94,
					phaserFeedback: 42,
					phaserStages: 97,
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 86, 86, 86, 71, 71, 57, 29, 14, 14, 14, 0, 29, 57, 29, 0, 29,
						43, 57, 57, 29, 14, 14, 29, 43, 29,
					],
					unison: "none",
					envelopes: [
						{ target: "phaserFreq", envelope: "tremolo6" },
						{
							target: "noteVolume",
							envelope: "twang -1",
						},
					],
				},
			},
			{
				name: "Light Bell",
				generalMidi: false,
				tags: ["pickedstring", "abyssbox", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["reverb", "ring modulation"],
					ringMod: 71,
					ringModHz: 90,
					rmWaveformIndex: 0,
					rmPulseWidth: 0,
					panDelay: 10,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						43, 71, 0, 100, 0, 100, 0, 86, 0, 0, 86, 0, 14, 71, 14, 14, 57, 14, 14, 43,
						14, 14, 43, 14, 14, 43, 14, 43,
					],
					unison: "shimmer",
					stringSustain: 71,
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
				},
			},
			{
				name: "Distortion Bass",
				generalMidi: false,
				tags: ["pickedstring", "abyssbox", "distortion", "bass"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.5 },
					],
					effects: ["note filter", "distortion", "bitcrusher", "phaser"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 0.5,
						},
					],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 0,
					phaserMix: 65,
					phaserFreq: 19,
					phaserFeedback: 61,
					phaserStages: 52,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 71,
					],
					unison: "none",
					stringSustain: 64,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 1 },
						{
							target: "phaserFeedback",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Phased Overdrive Guitar",
				generalMidi: false,
				tags: ["pickedstring", "abyssbox", "distortion"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					effects: ["note filter", "distortion", "bitcrusher", "phaser"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 0,
					phaserMix: 100,
					phaserFreq: 19,
					phaserFeedback: 61,
					phaserStages: 52,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 71,
					],
					unison: "none",
					stringSustain: 64,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 1 },
						{
							target: "phaserFeedback",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Phased Picked Guitar",
				generalMidi: false,
				tags: ["pickedstring", "abyssbox", "distortion"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"phaser",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 0,
					phaserMix: 77,
					phaserFreq: 19,
					phaserFeedback: 61,
					phaserStages: 52,
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 71,
					],
					unison: "none",
					stringSustain: 64,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 1 },
						{
							target: "phaserMix",
							envelope: "twang -1",
						},
					],
				},
			},
			{
				name: "Ghost House",
				generalMidi: false,
				tags: ["fm", "fm4op", "abyssbox"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "bitcrusher"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "punch" }],
				},
			},
			{
				name: "Chipwave Music Box",
				generalMidi: false,
				tags: ["chip", "customchip", "abyssbox"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus", "echo"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2.8284,
						},
					],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 24,
						"3": 23,
						"4": 23,
						"5": 22,
						"6": 21,
						"7": 19,
						"8": 17,
						"9": 14,
						"10": 11,
						"11": 7,
						"12": 3,
						"13": -1,
						"14": -5,
						"15": -8,
						"16": -10,
						"17": -12,
						"18": -14,
						"19": -16,
						"20": -17,
						"21": -18,
						"22": -19,
						"23": -20,
						"24": -21,
						"25": -22,
						"26": -23,
						"27": -23,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -23,
						"37": -23,
						"38": -22,
						"39": -21,
						"40": -20,
						"41": -19,
						"42": -18,
						"43": -17,
						"44": -16,
						"45": -14,
						"46": -12,
						"47": -10,
						"48": -8,
						"49": -5,
						"50": -1,
						"51": 3,
						"52": 7,
						"53": 11,
						"54": 14,
						"55": 17,
						"56": 19,
						"57": 21,
						"58": 22,
						"59": 23,
						"60": 23,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{ target: "noteFilterFreq", envelope: "decay 3", index: 1 },
						{
							target: "noteVolume",
							envelope: "punch",
						},
						{ target: "noteVolume", envelope: "decay 3" },
					],
				},
			},
			{
				name: "Chipwave Spooky Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "abyssbox", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2.8284,
						},
					],
					effects: ["vibrato", "bitcrusher", "chorus", "echo", "phaser"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					phaserMix: 100,
					phaserFreq: 16,
					phaserFeedback: 23,
					phaserStages: 32,
					panDelay: 10,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 24,
						"3": 23,
						"4": 23,
						"5": 22,
						"6": 21,
						"7": 19,
						"8": 17,
						"9": 14,
						"10": 11,
						"11": 7,
						"12": 3,
						"13": -1,
						"14": -5,
						"15": -8,
						"16": -10,
						"17": -12,
						"18": -14,
						"19": -16,
						"20": -17,
						"21": -18,
						"22": -19,
						"23": -20,
						"24": -21,
						"25": -22,
						"26": -23,
						"27": -23,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -23,
						"37": -23,
						"38": -22,
						"39": -21,
						"40": -20,
						"41": -19,
						"42": -18,
						"43": -17,
						"44": -16,
						"45": -14,
						"46": -12,
						"47": -10,
						"48": -8,
						"49": -5,
						"50": -1,
						"51": 3,
						"52": 7,
						"53": 11,
						"54": 14,
						"55": 17,
						"56": 19,
						"57": 21,
						"58": 22,
						"59": 23,
						"60": 23,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
				},
			},
		]),
	},
	{
		name: "LemmBox Presets",
		presets: toNameMap([
			// custom presets from this mod
			{
				name: "HD triangle wave",
				midiProgram: 80,
				tags: ["chip", "chipwave", "lemmbox", "chiptune"],
				settings: {
					type: "chip",
					eqFilter: [],
					effects: ["aliasing"],
					transition: "interrupt",
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					chord: "arpeggio",
					wave: "lemmbox HD triangle",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "HD sawtooth wave",
				midiProgram: 80,
				tags: ["chip", "chipwave", "lemmbox", "chiptune"],
				settings: {
					type: "chip",
					eqFilter: [],
					effects: ["aliasing"],
					transition: "interrupt",
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					chord: "arpeggio",
					wave: "lemmbox HD sawtooth",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "HD rounded wave",
				midiProgram: 80,
				tags: ["chip", "chipwave", "lemmbox", "chiptune"],
				settings: {
					type: "chip",
					eqFilter: [],
					effects: ["aliasing"],
					transition: "interrupt",
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					chord: "arpeggio",
					wave: "lemmbox HD rounded",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "trapasquare",
				midiProgram: 80,
				tags: ["chip", "chipwave", "lemmbox", "chiptune"],
				settings: {
					type: "chip",
					eqFilter: [],
					effects: ["aliasing"],
					transition: "interrupt",
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					chord: "arpeggio",
					wave: "lemmbox trapasquare",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "supersaw sax",
				midiProgram: 65,
				generalMidi: true,
				tags: ["supersaw", "lemmbox", "reed"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					effects: ["panning", "vibrato", "note filter", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 20,
					vibratoSpeed: 7,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					reverb: 29,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 24,
					pulseWidth: 16,
					decimalOffset: 0,
					dynamism: 83,
					spread: 8,
					shape: 33,
					envelopes: [{ target: "pulseWidth", envelope: "swell -1" }],
					isDrum: false,
				},
			},
			{
				name: "singing ghost",
				generalMidi: false,
				tags: ["fm", "fm6op", "lemmbox"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"vibrato",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 25,
					vibratoSpeed: 4,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 6,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
					isDrum: false,
				},
			},
			{
				name: "crystal bell",
				generalMidi: false,
				tags: ["pickedstring", "lemmbox", "idiophone"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "vibrato", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 0, 0, 100, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "bit wobble",
				generalMidi: false,
				tags: ["chip", "chipwave", "lemmbox", "retro"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					effects: ["panning", "transition type", "chord type", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 17,
					pan: 0,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 1.5,
					reverb: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					wave: "lemmbox trapasquare",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 512,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
					isDrum: false,
				},
			},
			{
				name: "muffled pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "lemmbox"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					effects: [
						"panning",
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
					],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 19,
					vibratoSpeed: 4,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "none", envelope: "swell -1" }],
					isDrum: false,
				},
			},
			{
				name: "otherworldly steelpan",
				generalMidi: false,
				tags: ["fm", "fm6op", "lemmbox"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 125, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 125, linearGain: 2 }],
					effects: [
						"panning",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					vibrato: "custom",
					vibratoDepth: 0.28,
					vibratoDelay: 19,
					vibratoSpeed: 2,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 1.4142,
						},
					],
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 58,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -6,
					algorithm: "1 2 3 (4 5)←6",
					feedbackType: "3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 6, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 6, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "punch", index: 5 }],
					isDrum: false,
				},
			},
			{
				name: "calm light",
				generalMidi: false,
				tags: ["fm", "fm4op", "lemmbox", "featured", "pad"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "vibrato", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 19,
					vibratoSpeed: 3,
					vibratoType: 0,
					pan: 0,
					panDelay: 10,
					reverb: 58,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "swell 1" }],
					isDrum: false,
				},
			},
			{
				name: "mellow triangle",
				generalMidi: false,
				tags: ["chip", "customchip", "lemmbox", "retro"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.5 }],
					effects: [
						"panning",
						"chord type",
						"detune",
						"vibrato",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: -40,
					vibrato: "custom",
					vibratoDepth: 0.28,
					vibratoDelay: 6,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.25,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					unison: "none",
					wave: "square",
					customChipWave: {
						"0": -1,
						"1": -1,
						"2": -4,
						"3": -4,
						"4": -8,
						"5": -8,
						"6": -11,
						"7": -11,
						"8": -14,
						"9": -14,
						"10": -17,
						"11": -17,
						"12": -20,
						"13": -20,
						"14": -24,
						"15": -24,
						"16": -23,
						"17": -23,
						"18": -20,
						"19": -20,
						"20": -17,
						"21": -17,
						"22": -14,
						"23": -14,
						"24": -11,
						"25": -11,
						"26": -7,
						"27": -7,
						"28": -4,
						"29": -4,
						"30": -1,
						"31": -1,
						"32": 2,
						"33": 2,
						"34": 5,
						"35": 5,
						"36": 8,
						"37": 8,
						"38": 12,
						"39": 12,
						"40": 15,
						"41": 15,
						"42": 18,
						"43": 18,
						"44": 21,
						"45": 21,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 21,
						"51": 21,
						"52": 18,
						"53": 18,
						"54": 15,
						"55": 15,
						"56": 12,
						"57": 12,
						"58": 8,
						"59": 8,
						"60": 5,
						"61": 5,
						"62": 2,
						"63": 2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
		]),
	},
	{
		name: "AwesomeBox Presets",
		presets: toNameMap([
			{
				name: "1/4 pulse lead",
				midiProgram: 80,
				tags: ["chip", "chipwave", "awesomebox", "featured", "retro", "lead"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: [
						"transition type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 14,
					aliases: true,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.417,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "glitch pulse",
				midiProgram: 80,
				tags: ["pwm", "awesomebox", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 2,
					discreteEnvelope: true,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 1,
						},
					],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					envelopes: [
						{ target: "pulseWidth", envelope: "note size" },
						{
							target: "pulseWidth",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "glitch blip",
				midiProgram: 80,
				tags: ["chip", "chipwave", "awesomebox", "retro"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 50,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.5,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					distortion: 57,
					aliases: true,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 14,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "punch" }],
				},
			},
			{
				name: "high saw",
				midiProgram: 80,
				tags: ["chip", "chipwave", "awesomebox"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -20,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2 }],
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 57,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "alien bass",
				midiProgram: 80,
				tags: ["chip", "chipwave", "awesomebox", "bass"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.125,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 8 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 8 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
					],
					distortion: 57,
					aliases: true,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "double pulse",
					unison: "none",
					envelopes: [
						{ target: "noteFilterFreq", envelope: "twang 2", index: 0 },
						{ target: "noteFilterFreq", envelope: "twang 3", index: 2 },
						{ target: "noteFilterFreq", envelope: "twang 3", index: 3 },
						{ target: "noteFilterFreq", envelope: "twang 2", index: 4 },
						{ target: "noteFilterAllFreqs", envelope: "note size" },
					],
				},
			},
			{
				name: "chip slap bass",
				midiProgram: 80,
				tags: ["chip", "customchip", "awesomebox", "bass", "picked"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					panDelay: 10,
					chorus: 14,
					echoSustain: 14,
					echoDelayBeats: 0.417,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 15,
						"3": 15,
						"4": 9,
						"5": 9,
						"6": -4,
						"7": -4,
						"8": 0,
						"9": 0,
						"10": -13,
						"11": -13,
						"12": -19,
						"13": -19,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -10,
						"19": -10,
						"20": 0,
						"21": 0,
						"22": -7,
						"23": -7,
						"24": -7,
						"25": -7,
						"26": 0,
						"27": 0,
						"28": 6,
						"29": 6,
						"30": -4,
						"31": -4,
						"32": 3,
						"33": 3,
						"34": -4,
						"35": -4,
						"36": 3,
						"37": 3,
						"38": 3,
						"39": 3,
						"40": 9,
						"41": 9,
						"42": 15,
						"43": 15,
						"44": 15,
						"45": 15,
						"46": 6,
						"47": 6,
						"48": -4,
						"49": -4,
						"50": -4,
						"51": -4,
						"52": -4,
						"53": -4,
						"54": -4,
						"55": -4,
						"56": -4,
						"57": -4,
						"58": 3,
						"59": 3,
						"60": 12,
						"61": 12,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 1" },
						{
							target: "noteVolume",
							envelope: "punch",
						},
					],
				},
			},
			{
				name: "chip guitar",
				midiProgram: 80,
				tags: ["chip", "customchip", "awesomebox", "featured"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.7071,
						},
					],
					effects: ["chord type", "note filter", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2 },
					],
					panDelay: 10,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.333,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -20,
						"2": -10,
						"3": -8,
						"4": -2,
						"5": 2,
						"6": 6,
						"7": 8,
						"8": 10,
						"9": 13,
						"10": 13,
						"11": 14,
						"12": -17,
						"13": -19,
						"14": -19,
						"15": -7,
						"16": -7,
						"17": -7,
						"18": -12,
						"19": -13,
						"20": -15,
						"21": -16,
						"22": -16,
						"23": -16,
						"24": -18,
						"25": -18,
						"26": -20,
						"27": -20,
						"28": -21,
						"29": -3,
						"30": -3,
						"31": -3,
						"32": 24,
						"33": 18,
						"34": 14,
						"35": 13,
						"36": 11,
						"37": 11,
						"38": 19,
						"39": 18,
						"40": 1,
						"41": 1,
						"42": 1,
						"43": 1,
						"44": 1,
						"45": 1,
						"46": 0,
						"47": 7,
						"48": 7,
						"49": 7,
						"50": 5,
						"51": 5,
						"52": 5,
						"53": 5,
						"54": 5,
						"55": 0,
						"56": 3,
						"57": 5,
						"58": 9,
						"59": 9,
						"60": 3,
						"61": 3,
						"62": 3,
						"63": 3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "awesome distorted bass",
				midiProgram: 80,
				tags: ["fm", "fm4op", "awesomebox"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 57,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "operatorAmplitude",
							envelope: "swell 2",
							index: 2,
						},
						{ target: "feedbackAmplitude", envelope: "twang 3" },
					],
				},
			},
			{
				name: "awesome distorted piano",
				midiProgram: 80,
				tags: ["harmonics", "awesomebox", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 100, 71, 71, 57, 57, 43, 57, 71, 29, 29, 43, 14, 14, 14, 0, 0, 0,
						0, 0, 57, 0, 0, 0, 29, 29, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "sandy distortion guitar",
				midiProgram: 80,
				tags: ["fm", "fm4op", "awesomebox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.5,
						},
					],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.7071,
						},
					],
					distortion: 57,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "2×", amplitude: 11, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "note size", index: 2 },
						{
							target: "feedbackAmplitude",
							envelope: "note size",
						},
					],
				},
			},
			{
				name: "awesome distorted electric piano",
				midiProgram: 80,
				tags: ["fm", "fm4op", "awesomebox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 1.4142 }],
					effects: ["distortion", "bitcrusher", "chorus", "reverb"],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 43,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←3←4",
					feedbackType: "3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "swell 1", index: 2 },
						{
							target: "feedbackAmplitude",
							envelope: "swell 2",
						},
					],
				},
			},
		]),
	},
	{
		name: "(compatible) Studio Box Presets",
		presets: toNameMap([
			{
				name: "Bluh",
				generalMidi: false,
				tags: ["harmonics", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter", "chorus", "echo", "reverb"],
					pitchShiftSemitones: 6,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 2000,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 2000,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 0.917,
					reverb: 77,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						0, 0, 0, 86, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8.5,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "climatic chip",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					panDelay: 0,
					chorus: 86,
					echoSustain: 57,
					echoDelayBeats: 1.083,
					reverb: 16,
					reverbfeedback: 77,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "trapezoid",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "ooh synth voice",
				generalMidi: false,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["chord type", "bitcrusher"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0.0938,
					fadeOutTicks: -12,
					spectrum: [
						86, 29, 0, 0, 29, 0, 0, 29, 0, 0, 0, 100, 43, 0, 100, 0, 100, 0, 86, 43, 0,
						29, 29, 29, 0, 29, 0, 14, 14, 0,
					],
					unison: "hum",
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
							waveform: 0,
							steps: 8,
						},
					],
				},
			},
			{
				name: "crazy custom chip",
				generalMidi: false,
				tags: ["chip", "customchip", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.7071,
						},
					],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
					],
					distortion: 100,
					aliases: false,
					ODmode: "0",
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 5,
						"1": 3,
						"2": 0,
						"3": -3,
						"4": -7,
						"5": -12,
						"6": -16,
						"7": -19,
						"8": -22,
						"9": -23,
						"10": -24,
						"11": -23,
						"12": -21,
						"13": -17,
						"14": -13,
						"15": -7,
						"16": -1,
						"17": 6,
						"18": 13,
						"19": 20,
						"20": -21,
						"21": -15,
						"22": -10,
						"23": -7,
						"24": -4,
						"25": -3,
						"26": -3,
						"27": -4,
						"28": -6,
						"29": -9,
						"30": -13,
						"31": -17,
						"32": -21,
						"33": 23,
						"34": 20,
						"35": 17,
						"36": 16,
						"37": 16,
						"38": 17,
						"39": 19,
						"40": 23,
						"41": -21,
						"42": -15,
						"43": -8,
						"44": -1,
						"45": 6,
						"46": 13,
						"47": 19,
						"48": -23,
						"49": -18,
						"50": -15,
						"51": -12,
						"52": -11,
						"53": -12,
						"54": -13,
						"55": -15,
						"56": -19,
						"57": -23,
						"58": 21,
						"59": 17,
						"60": 13,
						"61": 10,
						"62": 8,
						"63": 7,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "familiar organs",
				generalMidi: false,
				tags: ["fm", "fm4op", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					effects: ["vibrato"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.1138,
					fadeOutTicks: 12,
					algorithm: "1←(2 3) 2←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "10×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "3.5×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "music box 3",
				generalMidi: false,
				tags: ["pickedstring", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 28,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.7071 },
					],
					effects: ["vibrato", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 10,
					reverbfeedback: 77,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					harmonics: [
						57, 0, 0, 0, 0, 71, 100, 14, 43, 0, 0, 0, 0, 71, 57, 86, 0, 0, 0, 29, 0, 0,
						71, 0, 0, 0, 0, 0,
					],
					unison: "piano",
					stringSustain: 36,
					envelopes: [
						{
							target: "reverb",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Elevator Synth",
				generalMidi: false,
				tags: ["fm", "fm6op", "idiophone"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					panDelay: 0,
					reverb: 45,
					reverbfeedback: 77,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2←4 3←(5 6)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Peak Square",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"vibrato",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
						"phaser",
						"octave shift",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					pitchShiftOctaves: 12,
					detuneCents: -104,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					phaserMix: 100,
					phaserFreq: 87,
					phaserFeedback: 0,
					phaserStages: 58,
					panDelay: 0,
					chorus: 0,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 0,
					reverbfeedback: 77,
					revMode: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "phaserStages",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: true,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Phased Punch Sine",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["bitcrusher", "echo", "phaser"],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					phaserMix: 100,
					phaserFreq: 87,
					phaserFeedback: 0,
					phaserStages: 58,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "phaserStages",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
		]),
	},
	{
		name: "Dogebox2 Presets",
		presets: toNameMap([
			{
				name: "wibble bass",
				midiProgram: 36,
				tags: ["chip", "chipwave", "bass"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "vibrato", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 2,
					noteFilter: [],
					pan: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "1/4 pulse",
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
			{
				name: "square bell",
				midiProgram: 36,
				tags: ["chip", "chipwave", "idiophone"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [],
					effects: ["panning", "vibrato", "note filter", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 4,
					noteSimplePeak: 3,
					noteFilter: [{ type: "low-pass", cutoffHz: 1027.59, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1027.59, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "square",
					unison: "hum",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "scratcher",
				midiProgram: 36,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [],
					effects: ["panning", "vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					wave: "sawtooth",
					unison: "bowed",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 1" }],
				},
			},
			{
				name: "scratcher backer",
				midiProgram: 36,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					effects: ["panning", "note filter", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 }],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					pan: 0,
					panDelay: 10,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 45,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "punch" }],
				},
			},
			{
				name: "scratcher reverberator",
				midiProgram: 36,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 2,
						},
					],
					effects: ["panning", "chorus", "reverb"],
					pan: 0,
					panDelay: 10,
					chorus: 57,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 47,
					envelopes: [],
				},
			},
			{
				name: "superchared electric guitar",
				midiProgram: 29,
				tags: ["noise", "distortion"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 6,
					noteFilterType: true,
					noteSimpleCut: 5,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					distortion: 86,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "buzz",
					unison: "fifth",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			// { name: "synth kick 2", generalMidi: false, tags:["fm", "fm4op", "kick"], settings:{"type":"FM","eqFilter":[],"eqFilterType":false,"eqSimpleCut":10,"eqSimplePeak":0,"envelopeSpeed":12,"discreteEnvelope":false,"effects":[],"panDelay":10,"fadeInSeconds":0,"fadeOutTicks":-6,"algorithm":"1←(2 3 4)","feedbackType":"1⟲","feedbackAmplitude":0,"newOperators":[{"frequency":8,"hzOffset":0,"invert":false,"amplitude":15,"waveform":"sine","pulseWidth":5},{"frequency":1,"hzOffset":0,"invert":false,"amplitude":0,"waveform":"sine","pulseWidth":5},{"frequency":1,"hzOffset":0,"invert":false,"amplitude":0,"waveform":"sine","pulseWidth":5},{"frequency":1,"hzOffset":0,"invert":false,"amplitude":0,"waveform":"sine","pulseWidth":5}],"envelopes":[{"target":"operatorFrequency","envelope":"twang 1","index":0},{"target":"noteVolume","envelope":"twang 2"},{"target":"noteVolume","envelope":"punch"}]} },
		]),
	},
];
